import React from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function MaintenanceTasks() {

  const tasks = [

    {
      plot: "S253",
      task: "Watering",
      due: "Today"
    },

    {
      plot: "F412",
      task: "Fence Repair",
      due: "Tomorrow"
    },

    {
      plot: "Q330",
      task: "Plant Replacement",
      due: "This Week"
    }

  ];

  return (
    <div>

      <Navbar />
      <Sidebar />

      <div className="maintenancetasks-container">


        <h1>Maintenance Tasks</h1>

        <table className="plot-table">

          <thead>

            <tr>

              <th>Plot</th>
              <th>Task</th>
              <th>Due</th>

            </tr>

          </thead>

          <tbody>

            {tasks.map((t, i) => (

              <tr key={i}>

                <td>{t.plot}</td>
                <td>{t.task}</td>
                <td>{t.due}</td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>
  );
}

export default MaintenanceTasks;